/**
 * Format a date string to "YYYY-MM-DD".
 *
 * Ported from my-pymble-portal's formatDate, reimplemented natively (this repo
 * has no date-and-time dependency). Returns "" for empty/invalid input.
 */
export const formatDate = (value: string | string[]): string => {
	const datestr =
		Array.isArray(value) && value.length > 0
			? String(value[0])
			: String(value ?? "");

	if (!datestr || datestr.trim() === "") {
		return "";
	}

	const parsed = Date.parse(datestr);
	if (Number.isNaN(parsed)) {
		return "";
	}

	const d = new Date(parsed);
	const yyyy = d.getFullYear();
	const mm = String(d.getMonth() + 1).padStart(2, "0");
	const dd = String(d.getDate()).padStart(2, "0");
	return `${yyyy}-${mm}-${dd}`;
};
